import {
  PAYLOAD_MAP,
  TRIGGER_FIELDS,
  DETAILS_ELEMENTS_CONFIG,
  EVENTS_ELEMENTS_CONFIG,
  CONDITIONS_ELEMENTS_CONFIG,
  ACTIONS_ELEMENTS_CONFIG,
  COMPONENT_TYPES_TO_PAYLOAD_MAP,
  COMPONENT_TYPES
} from "../constants.js";
import {
  getPartsFromCombinedValue,
  getConfigKeys,
  getNextKey,
  validateFieldData,
  mapObjectOptions,
  mapArrayOptions,
  getSubSubConfigCombinedValue,
  getSubSubConfigCurrentKey,
  getSubSubConfigsFromItem,
  getOperatorFromCombinations,
} from "../utils.js";

export default {
  computed: {
    getAction() {
      return this.$route.params.trigger_action;
    },
    getType() {
      return this.$route.params.type;
    },
    getWorkflowId() {
      return this.$route.params?.workflowId;
    },
    getTriggerId() {
      return this.$route.params?.toolId;
    },
    isViewMode() {
      return this.$route.params.action === "view"
        || this.$route.params.trigger_action === "view"
        || this.$route.name == "check admin details"
        || this.$route.name == "Package Tools";
    },
    disabledSubmit() {
      const baseValidation = !(this.details?.model?.name?.trim().length)
        || Object.values(this.details?.errors || {}).some(e => e)
        || this.isInvalidEvent
        || this.isInvalidActions;

      return this.isConditionsPartiallyFilled
        ? baseValidation || this.isInvalidConditions
        : baseValidation;
    },
    isInvalidEvent() {
      return validateFieldData(this.events);
    },
    isInvalidActions() {
      return validateFieldData(this.actions);
    },
    isInvalidConditions() {
      let result = false;
      for (const block of this.conditions.blocks) {
        if (validateFieldData(block)) {
          result = true;
          break;
        }
      }

      return result;
    },
    isConditionsPartiallyFilled() {
      const baseValidation = this.conditions.blocks[0].model[0].type.length > 0;

      return this.conditions.blocks.length > 1
        ? baseValidation || this.conditions.blocks.length > 1
        : baseValidation;
    },
    isDescriptionIncluded() {
      return this.details.model.description.trim().length > 0
    },
    submitMessage() {
      return this.getTriggerId ? "Trigger is successfully updated" : "New Trigger is successfully created";
    },
    dropdownsWIthRequiredProps() {
      return {
        ...this.dropdownsCommonProps,
        validation: "required",
      }
    },
    dropdownsCommonProps() {
      return {
        class: "flex-1",
        type: "select",
        closeOnSelect: false,
        searchable: true,
        config: this.selectConfig,
        disabled: this.isLoading || this.isViewMode,
      }
    },
    selectConfig() {
      return { label: "name", trackBy: "id" };
    },
    detailsElements() {
      return DETAILS_ELEMENTS_CONFIG;
    },
    eventsElements() {
      return EVENTS_ELEMENTS_CONFIG;
    },
    conditionsElements() {
      return CONDITIONS_ELEMENTS_CONFIG;
    },
    actionsElements() {
      return ACTIONS_ELEMENTS_CONFIG;
    },
    rangeComponentType() {
      return COMPONENT_TYPES.Range
    },
    selectComponentType() {
      return COMPONENT_TYPES.SingleSelect;
    },
    emailComponentType() {
      return COMPONENT_TYPES.Email;
    },
    multiSelectGroupedComponentType() {
      return COMPONENT_TYPES.MultiSelectGrouped;
    },
  },

  methods: {
    getSubSubConfigsFromItem,

    getPayloadForEvents() {
      const field = TRIGGER_FIELDS.Events
      const keys = PAYLOAD_MAP.get(field);
      const result = keys
        .map(key => this.getItemPayload({ el: this[field].model, field, key }))
        .filter(item => item);

      return result;
    },

    getPayloadForConditions() {
      const field = TRIGGER_FIELDS.Conditions;
      const keys = PAYLOAD_MAP.get(field);

      const result = this[field].blocks.map((block, blockIndex) => {
        return {
          conditions: block.model.map((el, index) => {
            return keys
              .map(key => this.getItemPayload({ el, field, key, index, blockIndex }))
              .filter(item => item)
          }),
          conditions_operator: getOperatorFromCombinations(block.operator),
        }
      });

      return result;
    },

    getPayloadForActions() {
      const field = TRIGGER_FIELDS.Actions;
      const keys = PAYLOAD_MAP.get(field);

      const result = this[field].model
        .map((el, index) => {
          const { unit, value, isDelayed } = this[field].delay[index];
          return {
            actions: keys
              .map(key => this.getItemPayload({ el, field, key, index }))
              .filter(item => item),
            ...(isDelayed ? { action_delay_config : { unit, value: Number(value) } } : {})
          }
        });

      return result;
    },

    getItemPayload({ el, field, key, index, blockIndex }) {
      const item = el[key]
      const { idKey, configIdKey, configValueKey } = getConfigKeys(field);

      if (this.checkIsConditionsField(field)) {
        const component = this[field].blocks[blockIndex].components[index][key];

        switch (component) {
          case COMPONENT_TYPES.MultiSelect: {
            return {
              field_type: COMPONENT_TYPES_TO_PAYLOAD_MAP[component],
              selected_conditions: item.map(itm => {
                const { id, configId, configValue } = getPartsFromCombinedValue(itm.id);

                return {
                  [idKey]: id,
                  [configIdKey]: configId,
                  [configValueKey]: configValue,
                };
              }),
            };
          }

          case COMPONENT_TYPES.Range: {
            return {
              [idKey]: item[idKey],
              [configIdKey]: item.range.join("-"),
              [configValueKey]: item.range.join("-"),
              field_type: COMPONENT_TYPES_TO_PAYLOAD_MAP[component],
            };
          }

          default:
            break;
        }
      }

      if (this.checkIsActionsField(field)) {
        const component = this[field].components[index][key];
        console.log(item)

        switch (component) {
          case COMPONENT_TYPES.Email:
            return {
              [idKey]: item[idKey],
              [configIdKey]: item.text.trim(),
              [configValueKey]: item.text.trim(),
              field_type: COMPONENT_TYPES_TO_PAYLOAD_MAP[component],
            };

          case COMPONENT_TYPES.MultiSelectGrouped: {
            const { id } = getPartsFromCombinedValue(item[0].id);
            const transformedKey = JSON.stringify(
              item.map(itm => {
                const { configId } = getPartsFromCombinedValue(itm.id);
                return configId;
              })
            ).replace(/"([^"]*)"/g, "'$1'");

            return {
              field_type: COMPONENT_TYPES_TO_PAYLOAD_MAP[component],
              [idKey]: id,
              [configIdKey]: transformedKey,
              [configValueKey]: transformedKey,
            };
          }

          default:
            break;
        }
      }

      const combinedValue = item;
      const { id, configId, configValue } = getPartsFromCombinedValue(combinedValue);
      const source = this.resolveSource(field, blockIndex);

      if (Array.isArray(source)) {
        const result = source?.[index]?.[key]
          ?.find(el => el?.[idKey] === id && el?.[configIdKey] === configId && String(el?.[configValueKey]) === configValue);

        if (result && this.checkIsConditionsField(field)) {
          result["field_type"] = COMPONENT_TYPES_TO_PAYLOAD_MAP[this[field].blocks[blockIndex].components[index][key]]
        }

        return result;
      }

      return this[field].options[key]
        .find(el => el[idKey] === id && el[configIdKey] === configId && String(el[configValueKey]) === configValue);
    },

    getArrayItemFromOptions(combinedValue, field, currentKey, index, blockIndex) {
      const { idKey, configIdKey, configValue } = getConfigKeys(field);
      const { id, configId, configValueKey } = getPartsFromCombinedValue(combinedValue);
      const source = this.resolveSource(field, blockIndex);

      return source[index][currentKey]
        ?.find(el => el[idKey] === id && el[configIdKey] === configId && el[configValueKey] === configValue) ?? {};
    },

    getObjectItemFromOptions(combinedValue, field, currentKey) {
      const { idKey, configIdKey, configValue } = getConfigKeys(field);
      const { id, configId, configValueKey } = getPartsFromCombinedValue(combinedValue);
    
      return this[field].options[currentKey]
        ?.find(el => el[idKey] === id && el[configIdKey] === configId && el[configValueKey] === configValue) ?? {};
    },

    checkShowNestedSubConfig(item, field, nestedConfigIndex, itemIndex, blockIndex) {
      const currentKey = getSubSubConfigCurrentKey(nestedConfigIndex);
      const source = this.checkIsConditionsField(field) ? this[field].blocks[blockIndex] : this[field];
      const component = source?.components?.[itemIndex]?.[currentKey];

      if (component !== COMPONENT_TYPES.SingleSelect) return false;

      return this.checkShowSubConfig(
        getSubSubConfigCombinedValue(item, nestedConfigIndex),
        field,
        currentKey,
        itemIndex,
        blockIndex,
      );
    },

    checkShowSubConfig(combinedValue, field, currentKey, index, blockIndex) {
      if (this.isViewMode) {
          const nextKey = getNextKey(field, currentKey);
          if (nextKey) {
            const source = this.resolveSource(field, blockIndex);
            const nextItem = !isNaN(index)
              ? source[index][nextKey] ?? {}
              : this[field].options[nextKey] ?? {};
    
            return Object.keys(nextItem).length > 0;
          }
      }

      return !isNaN(index)
        ? this.getArrayItemFromOptions(combinedValue, field, currentKey, index, blockIndex).has_child
        : this.getObjectItemFromOptions(combinedValue, field, currentKey).has_child;
    },

    getMappedObjectOptions(field, key)  {
      return mapObjectOptions(this[field].options, field, key);
    },

    getMappedArrayOptions(field, key, elementIndex, blockIndex) {
      const source = this.resolveSource(field, blockIndex);
      return mapArrayOptions(source, field, key, elementIndex);
    },

    resolveSource(field, blockIndex) {
      return this.checkIsConditionsField(field)
        ? this[field].blocks[blockIndex]?.options
        : this[field].options
    },

    checkIsConditionsField(field) {
      return field === TRIGGER_FIELDS.Conditions;
    },

    checkIsActionsField(field) {
      return field === TRIGGER_FIELDS.Actions;
    },
  }
}
